// extracted by mini-css-extract-plugin
export default {"external":"aOTuSm","tag":"bOTuSm","text":"cOTuSm","block":"dOTuSm"};